<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item class="count-data">
                    <i class="el-icon-s-data" style="margin-right: 10px;"></i>
                    网络部门总数：{{deparmentCount}} 丨
                    <span>客户总数：{{customerNum}}，</span>
                    <span>加盟总数：{{joinNum}}，</span>
                    <span>合作总数：{{cooperateNum}}</span> 丨
                    <span>订单总数：{{orderNum}}</span>
                    <span style="padding-left: 10px;"
                          v-if="showPersonal">丨&nbsp;&nbsp;{{userName}}个人总数：{{personalCount}}</span>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                <el-form-item label="业务员">
                    <el-select v-model="dataForm.userId"
                               @focus="setHidden"
                               @blur="setHidden"
                               filterable
                               placeholder="请选择" clearable>
                        <el-option
                                v-for="item in userList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            <span style="float: left">
                                {{ item.label }}
                                <span style="color: #8492a6; font-size: 12px;">（{{item.isWork ? '离职' : '在职'}}）</span>
                            </span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="dataForm.cusPhone" placeholder="请输入电话" clearable></el-input>
                </el-form-item>
                <el-form-item label="类别">
                    <el-select v-model="dataForm.type"
                               filterable
                               placeholder="请选择" clearable>
                        <el-option
                                v-for="item in typeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道">
                    <el-select v-model="dataForm.channel"
                               filterable
                               placeholder="请选择" clearable>
                        <el-option
                                v-for="item in channelList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="小区地址">
                    <el-input v-model="dataForm.cusArea" placeholder="请输入小区地址" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="addOrUpdateHandle()"
                               v-if="isAuth('invite-net-add')">新增
                    </el-button>
                    <el-button type="danger" @click="deleteHandle()"
                               v-if="isAuth('invite-net-delete')"
                               :disabled="dataListSelections.length <= 0">批量删除
                    </el-button>
                    <el-button type="primary" @click="exportData()">导出数据
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    border
                    v-loading="dataListLoading"
                    @sort-change="customerSort"
                    @selection-change="selectionChangeHandle"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        header-align="center"
                        align="center"
                        width="80"
                        label="编号">
                </el-table-column>
                <el-table-column
                        prop="cusName"
                        header-align="center"
                        align="center"
                        width="100"
                        :show-overflow-tooltip="true"
                        label="客户姓名">
                </el-table-column>
                <el-table-column
                        prop="cusPhone"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="电话">
                </el-table-column>
                <el-table-column
                        prop="type"
                        header-align="center"
                        align="center"
                        width="100"
                        :sortable="'custom'"
                        :show-overflow-tooltip="true"
                        label="类别">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type===1">客户</el-tag>
                        <el-tag v-if="scope.row.type===2" type="success">加盟</el-tag>
                        <el-tag v-if="scope.row.type===3" type="warning">合作</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="cusArea"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="小区">
                </el-table-column>
                <el-table-column
                        prop="cusRemark"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="需求备注">
                    <template slot-scope="scope">
                        <span>{{scope.row.cusRemark===''?'暂无':scope.row.cusRemark}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="name"
                        header-align="center"
                        align="center"
                        width="100"
                        :show-overflow-tooltip="true"
                        label="业务员">
                </el-table-column>
                <el-table-column
                        prop="channel"
                        header-align="center"
                        align="center"
                        width="100"
                        :sortable="'custom'"
                        :show-overflow-tooltip="true"
                        label="渠道">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.channel === 1">官网</el-tag>
                        <el-tag v-if="scope.row.channel === 2" type="success">小程序</el-tag>
                        <el-tag v-if="scope.row.channel === 3" type="warning">美团</el-tag>
                        <el-tag v-if="scope.row.channel === 4" type="danger">新媒体</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="state"
                        header-align="center"
                        align="center"
                        :sortable="'custom'"
                        :show-overflow-tooltip="true"
                        label="客户情况">
                    <template slot-scope="scope">
                        <template v-if="scope.row.state === 1">
                            <el-tag v-if="scope.row.intention===1">A</el-tag>
                            <el-tag v-if="scope.row.intention===2" type="success">C</el-tag>
                            <el-tag v-if="scope.row.intention===3" type="info">无效</el-tag>
                        </template>
                        <template v-if="scope.row.state === 2">
                            <el-tag v-if="scope.row.order===1" type="warning">意向金</el-tag>
                            <el-tag v-if="scope.row.order===2" type="success">定金20000</el-tag>
                            <el-tag v-if="scope.row.order===3">货款80%</el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="dateTime"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="日期时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        header-align="center"
                        align="center"
                        width="150"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini"
                                   v-if="isAuth('invite-net-edit')"
                                   @click="addOrUpdateHandle(scope.row.id)">编辑
                        </el-button>
                        <el-button type="danger" size="mini"
                                   v-if="isAuth('invite-net-delete')"
                                   @click="deleteHandle(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="totalPage"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <invite-net-add-or-update v-if="addOrUpdateVisible" ref="inviteNet"
                                  @getDataList="getDataList()"></invite-net-add-or-update>
    </div>
</template>

<script>
    import {InviteNet} from "../../api/inviteNet";
    import {UdUser} from "../../api/udUser";
    import InviteNetAddOrUpdate from './invite-net-add-or-update';
    import {DateFormat} from "../../utils/dateformat";

    export default {
        name: "invite-net",
        data() {
            return {
                dataForm: {
                    type: '',
                    channel: '',
                    userId: '',
                    cusPhone: '',
                    cusArea: '',
                    column: '',
                    order: ''
                },
                typeList: [
                    {value: 1, label: '客户'},
                    {value: 2, label: '加盟'},
                    {value: 3, label: '合作'}
                ],
                channelList: [
                    {value: 1, label: '官网'},
                    {value: 2, label: '小程序'},
                    {value: 3, label: '美团'},
                    {value: 4, label: '新媒体'},
                ],
                userList: [],
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                showPersonal: false,
                personalCount: '',
                deparmentCount: '',
                customerNum: '',
                joinNum: '',
                cooperateNum: '',
                orderNum: ''
            }
        },
        computed: {
            userName() {
                let userList = this.userList;
                let current = this.dataForm.userId;
                for (let i = 0; i < userList.length; i++) {
                    if (userList[i].value === current) {
                        //console.log(userList[i].label);
                        return userList[i].label;
                    }
                }
                return '';
            }
        },
        components: {
            InviteNetAddOrUpdate
        },
        created() {
            this.getDataList();
            this.getUserList();
        },
        activated() {
            this.getDataList();
            this.getUserList();
        },
        watch: {
            'dataForm.userId': {
                handler(newValue, oldValue) {
                    if (newValue === '') {
                        this.setHidden();
                    }
                }
            }
        },
        methods: {
            /**
             * 获取记录数
             **/
            getCountData() {
                InviteNet.getIvNetCount().then(res => {
                    if (res.code === 0) {
                        this.customerNum = res.countData.customerNum;
                        this.joinNum = res.countData.joinNum;
                        this.cooperateNum = res.countData.cooperateNum;
                        this.orderNum = res.countData.orderNum;
                    }
                })
            },
            setHidden() {
                this.showPersonal = false;
            },
            /**
             * 自定义排序（客户情况）
             **/
            customerSort(obj) {
                this.dataForm.column = obj.prop;
                this.dataForm.order = obj.order;
                this.getDataList('search');
            },
            //数据导出
            exportData() {
                let sheet = '网络部邀约客户数据' + DateFormat.dateFormat(new Date());
                let columns = [
                    {key: 'id', title: '编号'},
                    {key: 'cusName', title: '客户姓名'},
                    {key: 'cusPhone', title: '电话'},
                    {key: 'type', title: '类别'},
                    {key: 'cusArea', title: '小区'},
                    {key: 'cusRemark', title: '需求备注'},
                    {key: 'name', title: '业务员'},
                    {key: 'channel', title: '渠道'},
                    {key: 'state', title: '客户情况'},
                    {key: 'intention', title: '意向'},
                    {key: 'order', title: '订单'},
                    {key: 'creationDate', title: '创建时间'}
                ];
                InviteNet.getIvNets().then(res => {
                    if (res.code === 0) {
                        let exportList = res.netList;
                        this.Excel.exportExcel(columns, exportList, sheet);
                    } else {
                        this.$message.info('数据太多无法导出，请联系管理员！')
                    }
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            getUserList() {
                UdUser.getUserList().then(res => {
                    if (res.code === 0) {
                        let userList = res.userList;
                        this.userList = [];
                        userList.forEach((item, index) => {
                            if (item.deparment === 5) { // 获取网络部人员
                                this.userList.push(item);
                            }
                        });
                    }
                })
            },
            /**
             * 获取数据
             * @param type
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                let params = {
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize,
                    'userId': this.dataForm.userId,
                    'cusPhone': this.dataForm.cusPhone,
                    'type': this.dataForm.type,
                    'channel': this.dataForm.channel,
                    'cusArea': this.dataForm.cusArea,
                    'column': this.dataForm.column,
                    'order': this.dataForm.order
                };
                InviteNet.getIvNetList(params).then(res => {
                    if (res.code === 0) {
                        this.dataList = res.page.list;
                        this.totalPage = res.page.totalCount;
                        this.deparmentCount = type === 'search' ? this.deparmentCount : res.page.totalCount;
                        if (this.dataForm.userId) {
                            this.showPersonal = true;
                            this.personalCount = res.page.totalCount;
                        } else {
                            this.showPersonal = false;
                        }
                        this.getCountData();
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 添加或编辑
             * @param id
             */
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.inviteNet.init(id)
                })
            },
            /**
             * 删除
             */
            deleteHandle(id) {
                let ids = id ? id.toString() : this.dataListSelections.map(item => item.id).join();
                //console.log(ids)
                let arrayIds = {'ids': ids};
                this.$confirm('此操作将删除邀约客户信息, 确定吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    InviteNet.deleteIvNet(arrayIds).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.$nextTick(() => {
                                        this.getDataList();
                                    })
                                }
                            })
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>

<style scoped>

    .count-data {
        margin: 5px 0;
    }

    .count-data /deep/ .el-breadcrumb__inner {
        color: #606266;
        padding-left: 10px;
        font-size: 18px;
        letter-spacing: 1px;
    }

    .count-data /deep/ .el-breadcrumb__inner:hover {
        color: black;
    }

</style>
